import React from 'react';

import {
    CardBottom,
    CardCollectionName,
    CardCollectionStack,
    CardFantasyPlayers,
    CardFantasyPrices,
    type CollectionCardProps,
    FantasyBottom,
    SingleCollectionCard,
} from '@pkg/components';

import { CardInside, Wrapper } from './styles';

export const CollectionCard = ({
    item,
    wishlistItem,
    chain,
    cardSize,
    isFantasyTile,
    isNFT,
    extraButton,
    ...rest
}: CollectionCardProps) => {
    const { collection, token_id } = wishlistItem || {};
    const { slug, metadata } = item || wishlistItem || {};
    const commonProps = metadata || wishlistItem;
    const { name, image_url } = commonProps || {};

    return (
        <Wrapper>
            <CardInside $cardSize={cardSize} $disableClick={rest.disableClick} $height={rest.height} $isNFT={isNFT}>
                <CardCollectionName
                    isFantasy={isFantasyTile}
                    hideLink={rest.disableClick}
                    disablePeek={rest.disablePeek}
                    name={name || ''}
                    image={image_url || ''}
                    slug={slug}
                    chain={chain}
                    collectionTokenCount={item?.tokenCount}
                />
                {isFantasyTile ? (
                    <SingleCollectionCard
                        chain={chain}
                        fallbackImage={image_url || ''}
                        slug={slug || rest.collection_slug}
                    />
                ) : (
                    <CardCollectionStack
                        chain={chain}
                        fallbackImage={image_url || ''}
                        slug={slug || rest.collection_slug}
                    />
                )}
                {isFantasyTile && (
                    <FantasyBottom>
                        {(rest.list_price || rest.last_sell) && (
                            <CardFantasyPrices
                                chain={chain}
                                floor_price_change={rest.floor_price_change}
                                listPriceEth={rest.list_price}
                                last_buy={rest.last_buy}
                                last_sell={rest.last_sell}
                            />
                        )}
                        {rest.players ? <CardFantasyPlayers playerCount={rest.players} /> : null}
                    </FantasyBottom>
                )}
                {!isFantasyTile && (
                    <CardBottom
                        contract={collection}
                        chain={chain}
                        token_id={token_id}
                        collection_slug={rest.collection_slug}
                        isCollectionTile
                    />
                )}
                {extraButton}
            </CardInside>
        </Wrapper>
    );
};
